import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { bgOne, bgTwo, bgThree, bgFour, bgFive, bgSix } from "../Entryfile/imagepath";
import LogInHeader from "./LogInHeader";
import useAuth from "./hooks/useAuth";
const Login = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const { loginAction, user, loginResult } = useAuth();
  const [password, setPassword] = useState("");
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  useEffect(() => {
    if (loginResult) {
      setIsLoading(false);
    }
  }, [loginResult, isLoading]);

  const onSubmit = (data) => {
    setIsLoading(true);
    sessionStorage.setItem("redirect", true);
    data.user = userData;
    data.password = password;
    const visitId = sessionStorage.getItem("tok_v");
    loginAction({
      user: data.user,
      password: data.password,
      visitor_id: visitId,
    });
    setIsLoading(true);
    setUserData("");
    setPassword("");
    // navigate('/')
  };

  //
  return (
    <>
      <div>
        {
          <div className="mb-5">
            <div
              style={{
                position: "relative",
                backgroundImage: `url(${bgFive})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                minHeight: "100vh",
              }}
            >
              {/* Overlay div for opacity */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.58)", // adjust alpha for darkness/lightness
                  zIndex: 1,
                }}
              ></div>

              {/* Main content on top of overlay */}
              <div
                className="row justify-content-center align-items-center"
                style={{ minHeight: "100vh", position: "relative", zIndex: 2 }}
              >
                <div className="col-sm-4 col-12 col-md-8 col-lg-4 me-lg-5 text-start p-0">
                  <div
                    className="py-4   login-style rounded"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.1)",
                      border: "1px solid gray",
                      WebkitBackdropFilter: "blur(10px)",
                    }}
                  >
                    <h2 className="fw-bold text-center mt-5 text-white">
                      LOG IN
                    </h2>
                    <form
                      className="px-5 pb-5"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <div className="mb-3">
                        <label
                          htmlFor="exampleFormControlInput1"
                          className="form-label text-start text-white"
                        >
                          Username
                        </label>
                        <input
                          value={userData}
                          onChange={(e) => setUserData(e.target.value)}
                          type="text"
                          placeholder="User Name"
                          className="form-control w-100"
                          id="exampleFormControlInput1"
                          required
                        />

                        <div className="mb-3">
                          <label
                            htmlFor="exampleFormControlInput2"
                            className="form-label text-start pt-2 text-white"
                          >
                            Password
                          </label>
                          <div className="pass-wrapper d-flex input-group mb-3">
                            <input
                              value={password}
                              className="form-control"
                              placeholder="Password"
                              name="password"
                              type={passwordShown ? "text" : "password"}
                              aria-describedby="basic-addon2"
                              onChange={(e) => setPassword(e.target.value)}
                              required
                            />
                            <span
                              className="input-group-text btn-eye"
                              id="basic-addon2"
                            >
                              <i
                                onClick={togglePasswordVisiblity}
                                className={
                                  passwordShown
                                    ? "fa fa-eye"
                                    : "fa fa-eye-slash"
                                }
                                aria-hidden="true"
                              ></i>
                            </span>
                          </div>
                        </div>
                        <br />
                        <button
                          type="submit"
                          className="btn buttonColor fs-5 w-100"
                        >
                          Log In
                          {isLoading ? (
                            <div
                              style={{ width: "20px", height: "20px" }}
                              className="spinner-border ms-2  text-light"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span> &rarr; </span>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </>
  );
};
export default Login;
